import { Routes as RoutesDom, Route } from "react-router-dom"
import Movies from "./views/Movies";

function App() {
  return (
    <RoutesDom>
        <Route path="/" element={< Movies />} />
        <Route path="*" element={<h1>Not Found</h1>} />
    </RoutesDom>
  );
}

export default App;
